import { LoadingStatusType, PeakExceptionResponseCode } from "@/enums/enums";
import API from "@/service/Index";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class TwoFactorAuth extends VuexModule {
  // Verify PIN State
  private verifyCurrentPINLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private verifyCurrentPINData: any = null;
  private verifyCurrentPINRemainAttempt: number | null = null;

  // Getters
  get GetVerifyCurrentPINLoadingStatus(): LoadingStatusType {
    return this.verifyCurrentPINLoadingStatus;
  }

  get GetVerifyCurrentPINData(): any {
    return this.verifyCurrentPINData;
  }

  get GetVerifyCurrentPINRemainAttempt(): number | null {
    return this.verifyCurrentPINRemainAttempt;
  }

  // Mutations
  @Mutation
  MutationVerifyCurrentPINLoadingStatus(status: LoadingStatusType) {
    this.verifyCurrentPINLoadingStatus = status;
  }

  @Mutation
  MutationVerifyCurrentPINData(data: any) {
    this.verifyCurrentPINData = data;
  }

  @Mutation
  MutationVerifyCurrentPINRemainAttempt(attempt: number | null) {
    this.verifyCurrentPINRemainAttempt = attempt;
  }

  @Mutation
  MutationClearVerifyCurrentPINData() {
    this.verifyCurrentPINData = null;
    this.verifyCurrentPINRemainAttempt = null;
  }

  // Actions
  @Action
  async DoVerifyPINCode(input: any) {
    return new Promise<void>(async (resolve) => {
      if (this.verifyCurrentPINLoadingStatus !== LoadingStatusType.Loading) {
        this.context.commit("MutationVerifyCurrentPINLoadingStatus", LoadingStatusType.Loading);

        try {
          const response = await API.UserService.DoVerifyPINCode(input);

          // ตรวจสอบว่า response มี exception หรือไม่
          if (response.data && response.data.exception) {
            this.context.commit("MutationVerifyCurrentPINLoadingStatus", LoadingStatusType.Fail);

            // เก็บ remainAttempt สำหรับ Invalid PIN Code
            if (
              response.data.exception.code === PeakExceptionResponseCode.InvalidPINCode &&
              response.data.exception.content?.remainAttempt
            ) {
              this.context.commit(
                "MutationVerifyCurrentPINRemainAttempt",
                response.data.exception.content.remainAttempt
              );
            }

            // เก็บ remainAttempt = 0 เมื่อถึงขีดจำกัด
            if (response.data.exception.code === PeakExceptionResponseCode.VerifyPINCodeMaxAttemptReached) {
              this.context.commit("MutationVerifyCurrentPINRemainAttempt", 0);
            }
          } else if (response.data && response.data.response) {
            // PIN ถูกต้อง
            this.context.commit("MutationVerifyCurrentPINData", response.data.response);
            this.context.commit("MutationVerifyCurrentPINLoadingStatus", LoadingStatusType.Success);
          } else {
            this.context.commit("MutationVerifyCurrentPINLoadingStatus", LoadingStatusType.Fail);
          }
        } catch (error: any) {
          this.context.commit("MutationVerifyCurrentPINLoadingStatus", LoadingStatusType.Fail);

          // เก็บ remainAttempt
          if (
            error.response?.data?.exception?.code === PeakExceptionResponseCode.InvalidPINCode &&
            error.response?.data?.exception?.content?.remainAttempt
          ) {
            this.context.commit(
              "MutationVerifyCurrentPINRemainAttempt",
              error.response.data.exception.content.remainAttempt
            );
          }

          // เก็บ remainAttempt = 0 เมื่อถึงขีดจำกัด
          if (error.response?.data?.exception?.code === PeakExceptionResponseCode.VerifyPINCodeMaxAttemptReached) {
            this.context.commit("MutationVerifyCurrentPINRemainAttempt", 0);
          }
        }
      }
      resolve();
    });
  }

  @Action
  ClearVerifyCurrentPINData() {
    this.context.commit("MutationClearVerifyCurrentPINData");
  }
}
